import { createActionGroup, props } from '@ngrx/store';

export const DomainExistenceCheckDialogActions = createActionGroup({
  source: '@vshapps/cdn/features/domain-existence-check-dialog',
  events: {
    'check id': props<{ id: string; }>()
  }
});

